import { render, staticRenderFns } from "./getElectricshock5Second.vue?vue&type=template&id=74ddfc15&scoped=true&"
import script from "./getElectricshock5Second.vue?vue&type=script&lang=js&"
export * from "./getElectricshock5Second.vue?vue&type=script&lang=js&"
import style0 from "./getElectricshock5Second.vue?vue&type=style&index=0&id=74ddfc15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ddfc15",
  null
  
)

export default component.exports